import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { motion } from "framer-motion";
import {
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import InvoiceLayout from "../components/layout/InvoiceLayout.jsx";
import configuration from "../config";

const CustomerInvoice = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = configuration;

  const selectedCompanyId = useSelector((state) => state.kyc.selectedCompanyId);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/api/v1/getInvoiceBykyc/${selectedCompanyId}`);
        
        
        if (Array.isArray(response.data)) {
          setInvoices(response.data);
        } else if (response.data && typeof response.data === 'object') {
          
          if (Array.isArray(response.data.data)) {
            setInvoices(response.data.data);
          } else {
            
            setInvoices([response.data]);
          }
        } else {
          
          setInvoices([]);
          console.warn("Received unexpected data format:", response.data);
        }
        
        setLoading(false);
      } catch (err) {
        console.error("Error fetching invoices:", err);
        setError("Failed to fetch invoices. Please try again later.");
        setLoading(false);
      }
    };

    if (selectedCompanyId) {
      fetchInvoices();
    } else {
      setLoading(false);
    }
  }, [selectedCompanyId]);

  if (loading) {
    return (
      <Container
        maxWidth="md"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Typography variant="h6" color="error" align="center">
          {error}
        </Typography>
      </Container>
    );
  }

 
  const invoicesArray = Array.isArray(invoices) ? invoices : [];

  return (
    <InvoiceLayout>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h4" gutterBottom>
            Your Invoices
          </Typography>
          {invoicesArray.length === 0 ? (
            <Typography variant="body1">No invoices found.</Typography>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Invoice ID</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoicesArray.map((invoice) => (
                    <TableRow key={invoice._id}>
                      <TableCell>{invoice.invoiceId || 'N/A'}</TableCell>
                      <TableCell>
                        {invoice.dueDate 
                          ? new Date(invoice.dueDate).toLocaleDateString() 
                          : 'N/A'}
                      </TableCell>
                      <TableCell>
                        {invoice.total !== undefined && invoice.total !== null
                          ? `₹${Number(invoice.total).toFixed(2)}`
                          : 'N/A'}
                      </TableCell>
                      <TableCell>{invoice.status || 'N/A'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </motion.div>
      </Container>
    </InvoiceLayout>
  );
};

export default CustomerInvoice;
